import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

const supportedActions = ['GET_POSTS_PREVIEW', 'GET_OLDER_POSTS_PREVIEW'];

export const consts = createReqConsts(
  'communities',
  'communityPostsPreview',
  supportedActions,
);

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'communities',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['communityId'],
    },
    'posts',
    'preview',
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/communityPostsPreview.js